module.exports = __webpack_public_path__ + "static/media/undo.242b002a.svg";